/** @format */

import { memo, useState } from "react";
import styled from "styled-components";

const ExpenseForm = ({ onSaveExpenseData, onCancel }) => {
	const [enteredTitle, SetEnteredTitle] = useState("");
	const [enteredAmount, SetEnteredAmount] = useState("");
	const [enteredDate, SetEnteredDate] = useState("");

	const titleChangeHandler = (event) => {
		SetEnteredTitle(event.target.value);
	};

	const dateChangeHandler = (event) => {
		SetEnteredDate(event.target.value);
	};

	const amountChangeHandler = (event) => {
		SetEnteredAmount(event.target.value);
	};

	const formSubmitHandler = (event) => {
		event.preventDefault();

		const expenseDateObject = {
			title: enteredTitle,
			amount: enteredAmount,
			date: new Date(enteredDate),
		};

		onSaveExpenseData(expenseDateObject);

		SetEnteredTitle("");
		SetEnteredAmount("");
		SetEnteredDate("");
	};

	return (
		<ExpenseFormWrapper onSubmit={formSubmitHandler}>
			<div className='new-expense__controls'>
				<div className='new-expense__control'>
					<label>Title</label>
					<input
						value={enteredTitle}
						type='text'
						onChange={titleChangeHandler}
					/>
				</div>

				<div className='new-expense__control'>
					<label>Amount</label>
					<input
						value={enteredAmount}
						onChange={amountChangeHandler}
						type='number'
						min='0.01'
						step='0.01'
					/>
				</div>

				<div className='new-expense__control'>
					<label>Date</label>
					<input
						value={enteredDate}
						onChange={dateChangeHandler}
						type='date'
						min='2020-01-01'
						max='2025-12-31'
					/>
				</div>
			</div>

			<div className='new-expense__actions'>
				<button type=' button' onClick={onCancel}>
					Cancel
				</button>
				<button type='submit' disabled={!enteredDate}>
					Add Expense
				</button>
			</div>
		</ExpenseFormWrapper>
	);
};

export default memo(ExpenseForm);

const ExpenseFormWrapper = styled.form`
	.new-expense__controls {
		display: flex;
		flex-wrap: wrap;
		gap: 1rem;
		margin-bottom: 1rem;
		text-align: left;
	}

	.new-expense__control label {
		font-weight: bold;
		margin-bottom: 0.5rem;
		display: block;
	}

	.new-expense__control input {
		font: inherit;
		padding: 0.5rem;
		border-radius: 6px;
		border: 1px solid #ccc;
		width: 20rem;
		max-width: 100%;
	}

	.new-expense__actions {
		text-align: right;
	}
`;
